module.exports = __webpack_public_path__ + "static/media/asenso-volcan.99a54484.jpg";